import React, { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import ContentEditor from "./components/ContentEditor";
const initialForm = {
    title: "",
    slug: "",
    excerpt: "",
    content: "",
    featuredImage: "",
    status: "draft",
    categoryId: "",
    tagIds: [],
};

const PostEditor = () => {
    const [form, setForm] = useState(initialForm);
    const [saving, setSaving] = useState(false);
    const [tags, setTags] = useState([]);
    const [categories, setCategories] = useState([]);
    const [message, setMessage] = useState("");
    const [apiError, setApiError] = useState("");
    
    useEffect(() => {
        fetchTags();
        fetchCategories();
    }, []);
    
    const fetchTags = async () => {
        try {
            const res = await axiosClient.get("/tags/");
            setTags(res.data.data || []);
        } catch (err) {
            setTags([]);
        }
    };
    
    const fetchCategories = async () => {
        try {
            const res = await axiosClient.get("/categories/");
            setCategories(res.data.data || []);
        } catch (err) {
            setCategories([]);
        }
    };
    
    const handleChange = (e) => {
        const { name, value, type, selectedOptions } = e.target;
        if (type === "select-multiple") {
            setForm({
                ...form,
                [name]: Array.from(selectedOptions, (option) => Number(option.value)),
            });
        } else {
            setForm({ ...form, [name]: value });
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setApiError("");
        setMessage("");
        try {
            const response = await axiosClient.post("/posts/", {
                ...form,
                tagIds: form.tagIds,
                categoryId: Number(form.categoryId),
            });
            setMessage(response.data.message || "Post created!");
            setForm(initialForm);
        } catch (err) {
            setApiError(
                err.response?.data?.message || "Failed to create post. Please try again."
            );
        } finally {
            setSaving(false);
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "850px" }}>
            <h2 className="mb-4">Create New Post</h2>
            
            {message && (
                <div className="alert alert-success" role="alert">
                    {message}
                </div>
            )}
            {apiError && (
                <div className="alert alert-danger" role="alert">
                    {apiError}
                </div>
            )}
            
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                        className="form-control"
                        name="title"
                        value={form.title}
                        onChange={handleChange}
                        required
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Slug</label>
                    <input
                        className="form-control"
                        name="slug"
                        value={form.slug}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label className="form-label">Content</label>
                    <ContentEditor
                        value={form.content}
                        onChange={(content) =>
                            setForm((prev) => ({ ...prev, content }))
                        }
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Excerpt</label>
                    <textarea
                        className="form-control"
                        name="excerpt"
                        value={form.excerpt}
                        onChange={handleChange}
                        rows={2}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Featured Image URL</label>
                    <input
                        className="form-control"
                        name="featuredImage"
                        value={form.featuredImage}
                        onChange={handleChange}
                    />
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                        className="form-select"
                        name="status"
                        value={form.status}
                        onChange={handleChange}
                    >
                        <option value="draft">Draft</option>
                        <option value="published">Published</option>
                    </select>
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Category</label>
                    <select
                        className="form-select"
                        name="categoryId"
                        value={form.categoryId}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select category</option>
                        {categories.map((cat) => (
                            <option key={cat.id} value={cat.id}>
                                {cat.name}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="mb-3">
                    <label className="form-label">Tags</label>
                    <select
                        className="form-select"
                        name="tagIds"
                        value={form.tagIds}
                        multiple
                        onChange={handleChange}
                    >
                        {tags.map((tag) => (
                            <option key={tag.id} value={tag.id}>
                                {tag.name}
                            </option>
                        ))}
                    </select>
                </div>
                
                
                
                
                <button type="submit" className="btn btn-primary" disabled={saving}>
                    {saving ? "Saving..." : "Publish"}
                </button>
            </form>
        </div>
    );
};

export default PostEditor;
